import axios from 'axios';
import { apiUrl } from '../../config/config';

const datasetCache = new Map();

export function findDatasetForTime(patientId, sinceMs) {
  if (!patientId || !sinceMs) return Promise.resolve(null);
  const key = `${patientId}:${sinceMs}`;
  if (datasetCache.has(key)) return datasetCache.get(key);
  const promise = axios
    .get(`${apiUrl}api/common/datasetForTime`, {
      params: { userid: patientId, time: new Date(sinceMs).toISOString() },
    })
    .then((res) => (res.data && res.data.databaseid) || null)
    .catch(() => null);
  datasetCache.set(key, promise);
  return promise;
}

const STRIP_SIZE = 15000;
const rpeakCache = new Map();

export function findRpeakForTime(patientId, databaseid, sinceMs) {
  if (!patientId || !databaseid || !sinceMs) return Promise.resolve(null);
  const key = `${patientId}:${databaseid}:${sinceMs}`;
  if (rpeakCache.has(key)) return rpeakCache.get(key);
  const promise = axios
    .get(`${apiUrl}api/common/rpeakForTime`, {
      params: { userid: patientId, databaseid, time: new Date(sinceMs).toISOString() },
    })
    .then((res) => {
      const rpeakindex = res.data && res.data.rpeakindex;
      if (typeof rpeakindex !== 'number') return null;
      const strip = Math.floor(rpeakindex / STRIP_SIZE);
      return {
        start: strip,
        end: strip,
        xValue: Math.round(rpeakindex - strip * STRIP_SIZE),
        diffSeconds: res.data.diffSeconds,
      };
    })
    .catch(() => null);
  rpeakCache.set(key, promise);
  return promise;
}

export function findSeekTargetForTime(patientId, sinceMs) {
  return findDatasetForTime(patientId, sinceMs).then((databaseid) => {
    if (!databaseid) return null;
    return findRpeakForTime(patientId, databaseid, sinceMs).then((seek) => {
      if (!seek) return { databaseid };
      return { databaseid, ...seek };
    });
  });
}
